import { gql } from '@apollo/client'

export const GET_SHIPPING_PERIOD_BASED_ON_PAYMENT_TIME = gql`
  query GetShippingPeriodBasedOnPaymentTime($orderNumber: String!) {
    order(number: $orderNumber) {
      id
      paymentTime {
        display
      }
      shippingPeriodBasedOnPaymentTime {
        processingTime
      }
    }
  }
`
